<template>
        <!-- The Modal -->
        <div id="modal" v-show="show">
            <div id="modal-background" v-on:click="closeOnClick ? closeModal() : ''">
                <!-- background uses so we can click on the background to close the modal -->
            </div>
            <!-- Modal content -->
            <div class="modal-container">
                <p name="modal-header"><slot name="modal-header"/></p>

                <slot name="modal-content"/>

                <slot name="modal-footer" class="footer"/>
            </div>
        </div>
</template>

<script>
import { Default } from '@/mixins/mixins';

export default {
    name: 'modal',
    mixins: [
        Default
    ],
    props: {
        'closeOnClick': {
            type: Boolean,
            default: true
        }
    },
    components: {},
    data() {
        return {
            show: false
        };
    },
    methods: {
        openModal: function() {
            this.show = true;
        },
        closeModal: function() {
            this.show = false;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    #modal {
        position: fixed; /* Stay in place */
        z-index: 3; /* Sit on top */
        /*padding-top: 100px; !* Location of the box *!*/
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */

        p[name="modal-header"] {
            font-weight: 600;
            padding: 0 0 15px 0;
        }

        #modal-background {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: -1;
        }

        /* Modal Content */
        .modal-container {
            background-color: #fefefe;
            margin: auto;
            margin-top: 100px;
            padding: 20px;
            border: 1px solid #888;
            width: max-content;
            border-radius: 10px;
            box-shadow: 0 5px 15px rgba(0,0,0,.5);

            .footer {
                display: table;
                width: auto;
                margin: 1em 0 0 auto;

                button:last-of-type {
                    margin-left: 1em;
                }
            }
        }
    }
</style>
